import React, { Component } from 'react';

class YourComponent extends Component {
  componentDidMount() {
    // Code to run after the component mounts
    const script = document.createElement("script");
    script.src = "//code.tidio.co/wir8s51vpps1vbt9vvhi1gfsgioaah5i.js";
    script.async = true;
    document.body.appendChild(script);
  }

  render() {
    return (
      // Your component's JSX
      <div>
        {/* Your component content */}
      </div>
    );
  }
}

export default YourComponent;



// WEBPACK FOOTER //
// ./client/src/components/TidioChat/index.js